const setApproved = (payload) => {
  return {
    type: "setApproved",
    payload,
  };
};
export default setApproved;
